import WhiteListCreate from './white-list.create';
import WhiteListEdit from './white-list.edit';

export default {
  create: WhiteListCreate,
  edit: WhiteListEdit,
};
